// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginPage_root__1DJUq","loginLogo":"LoginPage_loginLogo__3UWgV","loginForm":"LoginPage_loginForm__3gIuR","error":"LoginPage_error__1IxWp"};